import SectionHeading from './SectionHeading';
import { personFiles } from '@/mocks/material';

export default function PersonFiles() {
  return (
    <section id="person" className="mx-auto max-w-[1240px] scroll-mt-24 px-4 py-14 md:px-6 md:py-20">
      <SectionHeading
        index="05"
        kicker="人物档"
        title="按主角回溯，把散落的线索串起来"
        desc="同一个人在不同年份、不同平台漏下的旧料，归档时都归到同一张人物卡下。查某人直接按档号进，缺多少线索看进度条就明白。"
        linkText="检索全部人物档"
      />

      <div className="mt-10 grid gap-10 lg:grid-cols-[0.9fr_1.1fr] lg:gap-14">
        {/* 左：检索说明入口 */}
        <div className="flex flex-col justify-center">
          <div className="rounded-lg border border-background-200 bg-background-50 p-6 md:p-8">
            <h3 className="font-heading text-lg font-bold text-foreground-950">想查谁，报个名号</h3>
            <p className="mt-3 text-sm leading-7 text-foreground-600">
              人物档按行业与事件归类，同名同事件不会串档。点开任一档号，就能顺着
              <b className="font-semibold text-foreground-800">历史黑料 / 往期爆料</b>
              的时间顺序把这个人一整段看全。
            </p>
            <label className="mt-6 flex w-full items-center gap-3 rounded-md border border-background-300 bg-background-50 px-4 py-3 transition-colors focus-within:border-primary-400">
              <i className="ri-user-search-line text-base text-foreground-400" />
              <input
                type="text"
                placeholder="输入档号 / 人物 / 行业"
                className="w-full bg-transparent text-sm text-foreground-900 outline-none placeholder:text-foreground-400"
              />
            </label>
            <button
              type="button"
              className="mt-3 w-full whitespace-nowrap rounded-md bg-accent-600 px-5 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-accent-700"
            >
              打开人物档
            </button>
            <p className="mt-3 text-[11px] leading-5 text-foreground-400">
              完整度低于 60% 的档会标“待补齐”，翻旧账合集优先处理这批。
            </p>
          </div>
        </div>

        {/* 右：档列表 */}
        <div className="grid gap-3 sm:grid-cols-2">
          {personFiles.map((p) => (
            <article
              key={p.id}
              className="group flex flex-col gap-4 rounded-lg border border-background-200 bg-background-50 p-5 transition-colors hover:border-primary-200"
            >
              <div className="flex items-start justify-between gap-3">
                <div>
                  <span className="font-heading text-xs font-black tracking-widest text-primary-600">{p.code}</span>
                  <h3 className="font-heading mt-1 text-base font-bold text-foreground-950">{p.sector}</h3>
                </div>
                <button
                  type="button"
                  aria-label="打开人物档"
                  className="flex h-7 w-7 shrink-0 items-center justify-center rounded-md border border-background-200 text-foreground-400 transition-colors group-hover:border-primary-300 group-hover:text-primary-600"
                >
                  <i className="ri-corner-down-right-line text-sm" />
                </button>
              </div>

              <div className="space-y-1.5 text-[11px] text-foreground-500">
                <p className="flex items-center gap-2">
                  <i className="ri-time-line" />
                  活跃年份 {p.activeYears}
                </p>
                <p className="flex items-center gap-2">
                  <i className="ri-attachment-2" />
                  已收线索 {p.clueCount} 条
                </p>
              </div>

              <div className="mt-auto space-y-2">
                <div className="flex h-1.5 w-full overflow-hidden rounded-full bg-background-200">
                  <div className="h-full rounded-full bg-accent-500" style={{ width: `${p.completeness}%` }} />
                </div>
                <div className="flex items-center justify-between">
                  <span className="text-[11px] text-foreground-400">补齐度</span>
                  <span className="text-xs font-semibold text-accent-700">{p.completeness}%</span>
                </div>
                <div className="flex flex-wrap gap-1.5 pt-1">
                  {p.tags.map((t) => (
                    <span key={t} className="rounded-sm bg-background-200/80 px-1.5 py-0.5 text-[11px] text-foreground-500">
                      {t}
                    </span>
                  ))}
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}